import { getTeamUserList as getTeamUserListApi } from '@/api/team'

const state = {
  namespaced: true,
  state: {
    operatorsUsers: [],
    purchaseQuantity: 0, // operators 购买的数量
    avaliableQuantity: 0, // operators 剩余的邀请数量
    userTotal: 0,
    currentPage: 1, // 当前页
    pageSize: 15, // 每页的数量
    operatorsStatus: 'all', // 状态筛选 all、active、pending
    operatorsRequestStatus: false // operators 用户列表是否请求完成
  },
  mutations: {
    SET_OPERATORS_USERS(state, list) {
      state.operatorsUsers = list
    },
    SET_OPERATORS_REQUEST_STATUS(state, status) {
      state.operatorsRequestStatus = status
    },
    SET_PURCHASE_QUANTITY(state, quantity) {
      state.purchaseQuantity = quantity
    },
    SET_AVALIABLE_QUANTITY(state, quantity) {
      state.avaliableQuantity = quantity
    },
    SET_USER_TOTAL(state, total) {
      state.userTotal = total
    },
    SET_CURRENT_PAGE(state, currentPage) {
      state.currentPage = currentPage
    },
    SET_PAGE_SIZE(state, pageSize) {
      state.pageSize = pageSize
    },
    SET_OPERATORS_STATUS(state, status) {
      state.operatorsStatus = status
    },
    INIT_OPERATOR_STATE(state) {
      state.operatorsUsers = []
      state.purchaseQuantity = 0
      state.avaliableQuantity = 0
      state.userTotal = 0
      state.currentPage = 1
      state.pageSize = 15
      state.operatorsStatus = 'all'
      state.operatorsRequestStatus = false
    }
  },
  actions: {
    updateOperatorsStatus({ commit }, status) {
      commit('SET_OPERATORS_STATUS', status)
    },
    updatePageSize({ commit }, pageSize) {
      commit('SET_PAGE_SIZE', pageSize)
    },
    updateCurrentPage({ commit }, currentPage) {
      commit('SET_CURRENT_PAGE', currentPage)
    },
    getOperatorUserList({ state, commit }, search) {
      let params = {
        page: state.currentPage - 1,
        size: state.pageSize,
        status: state.operatorsStatus.toUpperCase(),
        role: 'OPERATOR',
        searchValue: search
      }
      return getTeamUserListApi(params).then(
        result => {
          try {
            let data = result.res.data
            let members = data.members || []
            let contentTotal = data.total_content || 0
            let total = data.total || 0
            let available = data.available || 0
            let totalPage = Math.ceil(contentTotal / state.pageSize)
            if (totalPage < state.currentPage) {
              commit('SET_CURRENT_PAGE', totalPage)
            }
            commit('SET_OPERATORS_USERS', members)
            commit('SET_PURCHASE_QUANTITY', total)
            commit('SET_AVALIABLE_QUANTITY', available)
            commit('SET_USER_TOTAL', contentTotal)
            commit('SET_OPERATORS_REQUEST_STATUS', true)
            return Promise.resolve()
          } catch (error) {
            commit('SET_OPERATORS_REQUEST_STATUS', false)
            return Promise.reject(error)
          }
        },
        error => {
          commit('SET_OPERATORS_REQUEST_STATUS', false)
          return Promise.reject(error)
        }
      )
    },
    initOperatorInfo({ commit }) {
      commit('INIT_OPERATOR_STATE')
    }
  }
}

export default state
